import { type EventNumber, getEventNumber } from '../../../schema/sport/entry.js';

/**
 * Converts a mask value to an array of event numbers.
 *
 * @param maskValue Mask value as a number where each bit represents an event.
 * @returns An array of event numbers (1-based index) that are represented by the mask.
 */
export function convertMaskToArray(maskValue: number): EventNumber[] {
  const stringValues = maskValue.toString(2).split('').toReversed();
  const result: EventNumber[] = [];
  for (const [index, value] of stringValues.entries()) {
    if (value === '1') {
      result.push(getEventNumber(index + 1)); // Convert 0-based index to 1-based event number
    }
  }
  return result;
}

/**
 * Toggles the nth bit in a mask value.
 *
 * @param value current value of mask outcomes
 * @param position position of the bit to toggle (1-based index)
 * @returns The new mask value with the nth bit toggled.
 */
export function toggleMaskNthBit(value: number, position: number): number {
  return value ^ (1 << (position - 1));
}
